<doka-modal-wrapper (close)="closeModal()">
  <ng-template #title>{{ "Common.Edit" | i18nextEager }} {{ country().countryCode }} </ng-template>

  <ng-template #content>
    <div class="flex flex-col gap-lg">
      <doka-text-field
        [readonly]="true"
        [(ngModel)]="country().countryName"
        data-testid="edit-country-name-input"
        [label]="'MasterData.CountriesGrid.Name' | i18nextEager"
      ></doka-text-field>

      <doka-select
        [value]="selectedMainIsoCurrencyCode()"
        (valueChange)="selectedMainIsoCurrencyCode.set($any($event))"
        data-testid="edit-country-main-currency-select"
        [label]="'MasterData.CountriesGrid.MainCurrency' | i18nextEager"
        [required]="true"
        [alert]="submitted() && !selectedMainIsoCurrencyCode() ? ('Common.Required' | i18nextEager) : ''"
      >
        @for (currencyCode of country().isoCurrencyCodes; track currencyCode) {
          <doka-select-option [value]="currencyCode" [label]="currencyCode" />
        }
      </doka-select>
    </div>
  </ng-template>
  <ng-template #footer>
    <div class="flx flex-col gap-sm w-full">
      <div class="flex w-full gap-md px-6 pt-4 items-center justify-end">
        <doka-button
          [disabled]="isLoading()"
          (click)="closeModal()"
          color="secondary"
          data-testid="edit-country-cancel-button"
          >{{ "Common.Cancel" | i18nextEager }}</doka-button
        >
        <doka-button
          type="submit"
          [disabled]="isLoading() || !selectedMainIsoCurrencyCode()"
          (click)="submit()"
          color="primary"
          data-testid="edit-country-save-button"
          >{{ "Common.Save" | i18nextEager }}</doka-button
        >
      </div>
    </div>
  </ng-template>
</doka-modal-wrapper>
